/**
 * TEDDY HATS — Header Scroll Behavior
 * Makes the header transparent on the homepage, turns solid on scroll.
 * Casablanca Paris-style sticky transparent header.
 */
(function () {
  'use strict';

  const SCROLL_THRESHOLD = 50;
  const TRANSPARENT_CLASS = 'header-wrapper--transparent';
  const SCROLLED_CLASS = 'header-wrapper--scrolled';

  function init() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    // Only apply transparent header on homepage
    const isHomepage =
      document.body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname === '';

    if (!isHomepage) return;

    // Start transparent
    headerWrapper.classList.add(TRANSPARENT_CLASS);

    // Offset page content to account for fixed header
    const header = headerWrapper.querySelector('.header');
    if (header) {
      document.body.style.paddingTop = '0px';
    }

    // Scroll handler
    let ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        const scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > SCROLL_THRESHOLD) {
          headerWrapper.classList.remove(TRANSPARENT_CLASS);
          headerWrapper.classList.add(SCROLLED_CLASS);
        } else {
          headerWrapper.classList.add(TRANSPARENT_CLASS);
          headerWrapper.classList.remove(SCROLLED_CLASS);
        }

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check (in case page loads scrolled)
    onScroll();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
